import React from 'react';
import cn from 'classnames';

import css from './Button.module.css';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export function Button({ className, children, ...restProps }: ButtonProps) {
  return (
    <button {...restProps} className={cn(css.button, className)}>
      {children}
    </button>
  );
}
